import React from 'react';

import './StartGuideTextContainer.scss';

function StartGuideTextContainer(props) {
  return <div styleName="container">{props.children}</div>;
}

export default React.memo(StartGuideTextContainer);